<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1354_9386)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.17 1.17C5.92 0.42 6.94 0 8 0C9.06 0 10.08 0.42 10.83 1.17C11.58 1.92 12 2.94 12 4C12 6.07 8.4 11.41 8.03 11.95C8.01 11.98 8 11.99 8 12C7.96 11.94 4 6.18 4 4C4 2.94 4.42 1.92 5.17 1.17ZM6.15 3.23C6 3.6 5.96 4 6.04 4.39C6.12 4.78 6.31 5.13 6.59 5.41C6.87 5.69 7.23 5.88 7.61 5.96C8 6.04 8.4 6 8.77 5.85C9.14 5.7 9.45 5.44 9.67 5.11C9.89 4.78 10.01 4.39 10.01 4C10.01 3.47 9.8 2.96 9.42 2.59C9.04 2.21 8.54 2 8.01 2C7.61 2 7.23 2.12 6.9 2.34C6.57 2.56 6.32 2.87 6.16 3.24L6.15 3.23ZM6.5 11.5C6.5 11.22 6.28 11 6 11H4C3.72 11 3.5 11.22 3.5 11.5C3.5 11.78 3.72 12 4 12H6C6.28 12 6.5 11.78 6.5 11.5ZM2.5 11.5C2.5 11.22 2.28 11 2 11H1C0.72 11 0.5 11.22 0.5 11.5C0.5 11.78 0.72 12 1 12H2C2.28 12 2.5 11.78 2.5 11.5Z"
            />
        </g>
        <defs>
            <clipPath id="clip0_1354_9386">
                <rect width="12" height="12" />
            </clipPath>
        </defs>
    </svg>
</template>
